export const ACTION = 'ACTION';
export const START_PROCESS = 'START_PROCESS';
export const CONDITION = 'CONDITION';
export const TRIGGER = 'TRIGGER';


export const IS_FOCUSED = 'IS_FOCUSED';
export const IS_GREYED = 'IS_GREYED';
export const IS_COMPLETED = 'IS_COMPLETED';
export const ADD_ACTION = 'ADD_ACTION';
export const ADD_TRIGGER = 'ADD_TRIGGER';
export const ACTION_EDGE = 'MY_EDGE';
export const TRIGGER_EDGE = 'TRIGGER_EDGE';
